import React from 'react'
import { PasswordSettingsContainer } from '@/components/containers/password-settings'
import { useTitle } from '@/hooks/use-title'
import SettingsIcon from '@material-ui/icons/Settings'

export const PasswordSettingsPage: React.FC = () => {
  useTitle('設定 / パスワード再設定', <SettingsIcon />)
  return <PasswordSettingsContainer />
}
